import type { FormListItem } from '../../service/types';

export function canReviewScsForm(form: FormListItem): boolean {
  return (
    form.role?.toLowerCase() === 'approver' &&
    ['active', 'approval', 'approved', 'rejected'].includes(form.formState || '') &&
    !form.scsProgress?.outOfScope &&
    /^Q[1-4]$/.test(form.scsProgress?.currentQuarter || '')
  );
}

export function showMainScsReview(form: FormListItem): boolean {
  return (
    canReviewScsForm(form) &&
    form.scsProgress?.quarters[form.scsProgress.currentQuarter]?.status === 'awaitingApproval'
  );
}
